import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';

import { Card } from 'components/legacy/Card';

import FiltersList from './FiltersList';
import './SidebarFilters.scss';

/**
 * Sidebar filters is an instance of FiltersList, configured for use
 * in the sidebar of the search page
 */

export function SidebarFilters({
	filters,
	showing,
	moveInDate,
	onClose,
	searchParams,
	facetCounts,
	onFilter,
	searchType,
	storageTypeUrls,
}) {
	const [modal, setModal] = useState(null);
	const onShowModal = (modalComponent) => setModal(() => modalComponent);
	const onHideModal = () => setModal(null);
	return (
		<Fragment>
			<div className={classnames('sidebar-filters', { showing })}>
				<Card header="Filter your search">
					<FiltersList
						facetCounts={facetCounts}
						listKey="sidebar-filter"
						filters={filters}
						moveInDate={moveInDate}
						searchParams={searchParams}
						onFilter={onFilter}
						onShowModal={onShowModal}
						searchType={searchType}
						showSearchTypeLink
						storageTypeUrls={storageTypeUrls}
					/>
				</Card>
			</div>
			{!!modal &&
				React.createElement(modal, {
					showing: true,
					onClose: onHideModal,
				})}
			<CSSTransition
				classNames="transition-fade-in"
				in={showing}
				unmountOnExit
				timeout={500}
			>
				<button
					type="button"
					className="search-filter-mask"
					onClick={onClose}
				/>
			</CSSTransition>
		</Fragment>
	);
}

SidebarFilters.propTypes = {
	filters: PropTypes.object,
	showing: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	moveInDate: PropTypes.string,
	searchType: PropTypes.string,
	searchParams: PropTypes.object.isRequired,
	storageTypeUrls: PropTypes.object.isRequired,
	facetCounts: PropTypes.object,
};

export default SidebarFilters;
